// Module
var code = "<template> <require from=\"./path-nav.scss\"></require> <slot></slot> </template> ";
// Exports
module.exports = code;